import React from "react";
import styled from "styled-components";
import { ThemeColor } from "../styles/theme";

import { useInView } from "react-intersection-observer";
import { animated, useSpring } from "react-spring";
import { device } from "../styles/media-query";

const Container = styled.footer`
  height: 272px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${device.tablet} {
    padding: 12rem 6rem;
  }
  ${device.mobile} {
    padding: 8rem 2rem;
    flex-direction: column;
    align-items: unset;
    justify-content: unset;
  }

  ${device.desktop} {
    margin: 0 auto;
    padding: 12rem 4rem;
    max-width: 1080px;
  }
`;

const Email = styled.p`
  color: ${ThemeColor.WHITE};
  font-size: 1.8rem;
  ${device.mobile} {
    text-align: start;
    width: 100%;
  }
`;

// const IconContainer = styled.div`
//   display: flex;
//   align-items: center;
//   color: white;
//   ${device.mobile} {
//     width: 100%;
//     justify-content: flex-end;
//     ${device.mobile} {
//       margin-top: 2rem;
//     }
//   }
// `;

// const Icon = styled.div`
//   width: 3.2rem;
//   height: 3.2rem;
//
//   &:not(:last-child) {
//     margin-right: 3rem;
//   }
// `;

function Contact() {
  const { ref, inView } = useInView({ rootMargin: "-120px 0px 0px 0px" });

  const animationStyle = useSpring({
    from: {
      transform: `translateY(30px)`,
      opacity: 0,
    },
    to: {
      transform: inView ? "translateY(0px)" : "translateY(30px)",
      opacity: inView ? 1 : 0,
    },
    config: { duration: 500 },
  });

  return (
    <div>
      <animated.div style={animationStyle}>
        <Container id={"contact"} ref={ref}>
          <Email>thehyperdao@gmail.com</Email>
          {/*<IconContainer>*/}
          {/*  <Icon>*/}
          {/*    <Img src={Discord} alt={"discord"} />*/}
          {/*  </Icon>*/}
          {/*  <Icon>*/}
          {/*    <Img src={Twitter} alt={"twitter"} />*/}
          {/*  </Icon>*/}
          {/*  <Icon>*/}
          {/*    <Img src={Medium} alt={"medium"} />*/}
          {/*  </Icon>*/}
          {/*</IconContainer>*/}
        </Container>
      </animated.div>
    </div>
  );
}

export default Contact;
